/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm} from '@insticator/insticator-ui'; // iui-utils


/* ++++++++++ --------------- COMMENTING : GET CODE : STYLES --------------- ++++++++++ */
export default theme => ({
  commentingconfigpage: {

  }
});
